document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.querySelector('#product-grid');

  if (!productGrid) return;

  const updateRatings = (cards) => {
    cards.forEach((card) => {
      const stampedContainer = card.querySelector(
        '.stamped-product-reviews-badge'
      );

      const ratingWrapper = card.querySelector('.pcg-rating');

      if (!stampedContainer || !ratingWrapper) return;

      const badge = stampedContainer.querySelector('.stamped-badge');
      const caption = stampedContainer.querySelector('.stamped-badge-caption');

      if (!badge || !caption) return;

      const rating = parseFloat(badge.dataset.rating);
      const reviews = parseInt(caption.dataset.reviews, 10);

      if (Number.isNaN(rating) || Number.isNaN(reviews)) return;

      if (reviews === 0) {
        ratingWrapper.style.visibility = 'hidden';
        ratingWrapper.style.opacity = '0';
        return;
      }

      const ratingValue = ratingWrapper.querySelector(
        '.pcg-rating__value'
      );

      const ratingCount = ratingWrapper.querySelector(
        '.pcg-rating__count'
      );

      const stars = ratingWrapper.querySelector(
        '.pcg-rating__stars'
      );

      if (ratingValue) {
        ratingValue.textContent = rating.toFixed(1);
      }

      if (ratingCount) {
        ratingCount.textContent = `(${reviews} reviews)`;
      }

      if (stars) {
        const ratingPercent = Math.min(
          100,
          Math.max(0, (rating / 5) * 100)
        );

        stars.style.setProperty(
          '--rating-percent',
          `${ratingPercent}%`
        );
      }

      ratingWrapper.style.visibility = '';
      ratingWrapper.style.opacity = '';
    });
  };

  const waitForBadges = (cards, attempts = 0) => {
    const readyCards = cards.filter((card) =>
      card.querySelector(
        '.stamped-product-reviews-badge .stamped-badge'
      )
    );

    if (readyCards.length === cards.length) {
      updateRatings(cards);
      return;
    }

    if (attempts >= 100) {
      updateRatings(readyCards);
      return;
    }

    setTimeout(() => {
      waitForBadges(cards, attempts + 1);
    }, 100);
  };


  const initialCards = [
    ...productGrid.querySelectorAll('.grid__item')
  ];

  waitForBadges(initialCards);


  let loadMoreTimeout;

  const gridObserver = new MutationObserver((mutations) => {
    const addedCards = [];

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches('.grid__item')) {
          addedCards.push(node);
        }

        node.querySelectorAll?.('.grid__item').forEach((card) => {
          addedCards.push(card);
        });
      });
    });

    if (!addedCards.length) return;

    clearTimeout(loadMoreTimeout);

    loadMoreTimeout = setTimeout(() => {
      if (
        typeof window.StampedFn?.loadBadges === 'function'
      ) {
        window.StampedFn.loadBadges();
      }

      waitForBadges(addedCards);
    }, 100);
  });

  gridObserver.observe(productGrid, {
    childList: true,
  });
});